export default __webpack_public_path__ + "static/media/john_lewis.e3c3b565.png";